import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_RESET,
} from '../Constants/actionTypes';

const initialState = {
  loading: false,
  sent: false,     // drives the “success panel” UI
  error: null,
};

const forgotPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
      return { ...state, loading: true, error: null, sent: false };
    case FORGOT_PASSWORD_SUCCESS:
      return { ...state, loading: false, sent: true, error: null };
    case FORGOT_PASSWORD_FAILURE:
      return { ...state, loading: false, sent: false, error: action.payload || null };
    case FORGOT_PASSWORD_RESET:
      return initialState;
    default:
      return state;
  }
};

export default forgotPasswordReducer;
